import React, { useRef, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Button,
  Select,
  message,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import btnStyles from "../../../styles/Custom/Button.module.css";
import inputStyles from "../../../styles/Custom/Input.module.css";
import {
  approveRejectServiceRequestApi,
  refreshServiceRequestsCount,
} from "../../../services/serviceRequests.services";

const ApproveRejectModal = ({ open, setOpen, record, refresh }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        id: record?.id,
        action: values.status,
        admin_comment: values.comments || "",
      };
      const res = await approveRejectServiceRequestApi(record?.id, payload);
      message.success(res?.data?.message || "Request processed successfully");
      setLoading(false);
      setOpen(false);
      form.resetFields();
      refreshServiceRequestsCount().catch((err) => {
        console.error("Failed to refresh service request counts", err);
      });
      if (refresh) {
        refresh();
      }
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Something went wrong"
      );
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={
        <Row>
          <Col span={12} className="flex-start">
            <Typography
              style={{
                marginLeft: "12px",
                fontWeight: "400",
                fontSize: "20px",
              }}
            >
              Approve/Reject Service Request
            </Typography>
          </Col>
          <Col span={12} className="flex-end">
            <CloseOutlined onClick={handleCancel} />
          </Col>
        </Row>
      }
      closeIcon={null}
      width={"40%"}
      open={open}
      footer={
        <div className="flex-end" style={{ gap: "24px" }}>
          <Form.Item>
            <Button
              type="primary"
              ghost
              className={btnStyles.mdBtn}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading}
              htmlType="submit"
              type="primary"
              className={btnStyles.mdBtn}
              onClick={() => {
                if (formRef.current) {
                  formRef.current.submit();
                }
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </div>
      }
      onCancel={handleCancel}
      maskClosable={false}
    >
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        ref={formRef}
      >
        <Form.Item
          label="Status"
          name="status"
          rules={[
            {
              required: true,
              message: "Please select a status!",
            },
          ]}
        >
          <Select
            placeholder="Select status"
            className={inputStyles.mdSelect}
            style={{ width: "100%" }}
          >
            <Select.Option value="approve">Approve</Select.Option>
            <Select.Option value="reject">Reject</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Comments" name="comments">
          <Input.TextArea
            placeholder="Enter comments (optional)"
            className={inputStyles.mdInput}
            rows={4}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ApproveRejectModal;
